<!-- @format -->

<ng-container *transloco="let t">
  <div class="container sis-pt-md">
    <sis-breadcrumbs></sis-breadcrumbs>
    <sis-page-title [title]="t('COURSE_CART.COURSE_CART_PAGE_TITLE')" [showCrumbs]="true" />
    @if (courseCartCourseUnits$ | async; as courseIdsCart) {
      <div class="row">
        @if (courseIdsCart && courseIdsCart.length > 0) {
          <div class="col-md-12">
            <table class="sis-table styled-table">
              <caption>{{ t("COURSE_CART.COURSE_CART_PAGE_CAPTION") }}</caption>
              <thead>
                <tr>
                  <th class="col-2">{{ t("COURSE_UNIT_CODE") }}</th>
                  <th class="col-4">{{ t("COURSE_UNIT_NAME") }}</th>
                  <th class="col-2 col-lg-1">{{ t("COURSE_UNIT_CREDITS") }}</th>
                  <th class="col-2">{{ t("COURSE_UNIT_ORGANIZATION") }}</th>
                  <th class="col-2 col-lg-3 sis-table__header__last">{{ t("COURSE_CART.REMOVE_ACTION_HEADER") }}</th
                  ><!-- remove button header -->
                </tr>
              </thead>
              <tbody class="sis-table__body" data-cy="course-cart-course-units">
                @for (courseUnitId of courseIdsCart; track courseUnitId) {
                  <tr class="sis-table__body__row" data-cy="course-cart-course-unit">
                    @if (courseUnitId | courseUnit | async; as courseUnit) {
                      <td class="col-2">
                        <sis-button
                          [link]="true"
                          (clicked)="openCourseUnitInfo(courseUnitId)"
                          [ariaLabel]="courseUnit.code + ' ' + (courseUnit.name | localizedString) + ' ' + t('ARIA_LABEL.OPEN_INFO')">
                          <sis-icon icon="brochure"></sis-icon>{{ courseUnit.code }}
                        </sis-button>
                      </td>
                      <td class="col-4">
                        <span>{{ courseUnit?.name | localizedString }}</span>
                      </td>
                      <td class="col-2 col-lg-1">
                        <span>{{ courseUnit?.credits | creditRange }}</span>
                      </td>
                      <td class="col-2">
                        @for (org of courseUnit?.organisations; track org; let isLast = $last) {
                          <span>
                            {{ (org?.organisationId | organisation | async)?.name | localizedString }}
                            @if (!isLast) {
                              <span>,</span>
                            }
                          </span>
                        }
                      </td>
                      <td class="col-2 col-lg-3">
                        @if (isLoggedIn) {
                          <fudis-button
                            [variant]="'tertiary'"
                            [label]="'SIS_COMPONENTS.STUDY.PLACE_TO_PLAN' | translate"
                            (handleClick)="addToPlan(courseUnit)"
                            [ariaLabel]="t('SIS_COMPONENTS.STUDY.PLACE_TO_PLAN') + ' ' + (courseUnit?.name | localizedString)">
                          </fudis-button>
                          <fudis-button
                            [variant]="'tertiary'"
                            data-cy="remove-from-course-cart"
                            (handleClick)="removeCourseUnitFromCourseCart(courseUnit?.id)"
                            [icon]="'list-minus'"
                            [label]="t('REMOVE_FROM_CART_SHORT')"
                            [ariaLabel]="t('ARIA_LABEL.REMOVE_FROM_CART') + ' ' + (courseUnit?.name | localizedString)">
                          </fudis-button>
                        }
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <p>{{ t("COURSE_CART.COURSE_CART_IS_EMPTY") }}</p>
          <span class="guidance">{{ t("COURSE_CART.ADD_TO_EMPTY_COURSE_CART") }}</span>
        }
      </div>
    }
  </div>
</ng-container>
